<template lang="pug">
page(
    main-title="Промокоды"
)
    template(slot="description") Просмотр <span class="text-bold">промокодов</span>
        |, действующих на расчет стоимости доставки 
        
    .panel
        .panel-heading 
            button.btn.btn-wide.btn-default(@click="edit({})") Добавить
        .panel-body
            .row
                .col-md-6(v-for='promocodes_ in promocodes_splitted')
                    p(v-for='promocode in promocodes_') 
                        a(@click="edit(promocode)")
                            code {{ promocode.promocode }}
                        span  – {{ getDescription(promocode) }}
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
    name: 'Promocodes',
    created() {
        this.getDataHook();
    },
    methods: {
        getDataHook() {
            this.$store.dispatch('loadPromocodes');
        },
        edit(promocode) {
            this.$store.commit('changeEditedPromocode', promocode);
            this.$router.push({name: 'EditPromocode'});
        },
        getDescription(promocode) {
            let res = [];
            if (promocode.delivery_methods && promocode.delivery_methods.length) {
                res.push(promocode.delivery_methods.map((item) => item.name)
                         .join(', '));
            } else res.push('Все способы доставки');

            if (promocode.pvzs && promocode.pvzs.length) {
                res.push(`ПВЗ ${promocode.pvzs.map(item => item.name).join(', ')}`);
            }

            return res.join(', ');
        }
    },
    computed: {
        ...mapGetters([
            'promocodes'
        ]),
        promocodes_splitted() {
            let l = Math.round(this.promocodes.length / 2);
            return [this.promocodes.slice(0, l), this.promocodes.slice(l)];
        }
    }
};
</script>


// WEBPACK FOOTER //
// src/components/promocodes/Promocodes.vue